import { NavigationDataResponse } from '@/api/navigationApi/types.gen'

export const resolveStartFlowAction = (
  routeModuleState: NavigationDataResponse['route_module_state'] | undefined
): 'resume' | 'cameraCheck' | 'none' => {
  if (routeModuleState === 'Paused') return 'resume'
  if (routeModuleState === 'Fetched') return 'cameraCheck'
  return 'none'
}

export const shouldRenderAlerts = (cameraCheckVisible: boolean): boolean => !cameraCheckVisible
